import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { inputLabelStyles } from "@store/theme/common/mixins";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(dateRangeStyles, {
    datePickersWrapper: {
        css: css`
            display: flex;

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["column", null, "row", null, null], properties: ["flex-direction"] }],
                    mediaOptions.min,
                )}

            label {
                ${inputLabelStyles()}
            }
        `,
    },
    fromDate: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
            formField: css`
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: [null, null, "10px", null, null], properties: ["padding-right"] }],
                        mediaOptions.min,
                    )}
            `,
        },
    },
    toDate: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
            formField: css`
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: [null, null, "10px", null, null], properties: ["padding-left"] }],
                        mediaOptions.min,
                    )}
            `,
        },
        labelProps: {
            color: "common.background",
        },
    },
});
